import { render } from "./detail.vue?vue&type=template&id=01b2dc48&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=01b2dc48&scoped=true&lang=css"

import exportComponent from "F:\\Program\\JAVA\\JavaProject\\DXD物流系统\\logisticsWeb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b2dc48"]])

export default __exports__